import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["fileInput", "submitButton"];
  static values = {
    noFileMessage: String,
    confirmMessage: String,
  };

  confirm(event) {
    const file = this.fileInputTarget.files[0];

    if (!file) {
      event.preventDefault();
      alert(this.noFileMessageValue);
      return;
    }

    if (!confirm(this.confirmMessageValue)) {
      event.preventDefault();
    }
  }
}
